/**
 * @generated SignedSource<<f739ad9f42a391c22cb3ed4a56f30933>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type QuestionLevelEnum = "advanced" | "basic" | "intermediate";
export type CreateQuestionInput = {
  clientMutationId?: string | null | undefined;
  description?: string | null | undefined;
  expectation?: string | null | undefined;
  firmId?: string | null | undefined;
  industryIds?: ReadonlyArray<string> | null | undefined;
  level?: QuestionLevelEnum | null | undefined;
  maxDuration?: number | null | undefined;
  skillIds?: ReadonlyArray<string> | null | undefined;
  specializationIds?: ReadonlyArray<string> | null | undefined;
  tagNames?: ReadonlyArray<string> | null | undefined;
  title: string;
};
export type SubmitQuestionDialog_Mutation$variables = {
  input: CreateQuestionInput;
};
export type SubmitQuestionDialog_Mutation$data = {
  readonly createQuestion: {
    readonly question: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type SubmitQuestionDialog_Mutation = {
  response: SubmitQuestionDialog_Mutation$data;
  variables: SubmitQuestionDialog_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateQuestionPayload",
    "kind": "LinkedField",
    "name": "createQuestion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Question",
        "kind": "LinkedField",
        "name": "question",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SubmitQuestionDialog_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SubmitQuestionDialog_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d4aa31b4e5015e54b141d10a6e423d33",
    "id": null,
    "metadata": {},
    "name": "SubmitQuestionDialog_Mutation",
    "operationKind": "mutation",
    "text": "mutation SubmitQuestionDialog_Mutation(\n  $input: CreateQuestionInput!\n) {\n  createQuestion(input: $input) {\n    question {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5e2c548e1973bccca9b0323b13c2d66f";

export default node;
